import React from "react";
import { Modal } from "react-bootstrap";
import "./onboardingCopyTradeService.css";
import BubbleSvgButton from "../CommonComponents/BubbleSvgButton/BubbleSvgButton";
// import setupImage from "../../../assets/images/copyTradeService.svg";
import setupImage from "../../../assets/images/onboardingImages/setting.gif";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { globalCurrentPageTitle } from "../../../store/globalstore";
import { useAtom } from "jotai";
import { resetOnBoardingStartContext } from "../../../redux/users/usersSlice";
import { useDispatch } from "react-redux";
import { showNotificationToast } from "../../../helpers/toast/toastify";

const OnboardingCopyTradeService = () => {
  const { state:locationState } = useLocation();
  const navigate=useNavigate();
  const selectedCommunity = useSelector(
      (state) => state?.multiCommunity?.currentCommunity
    );
  const { user } = useSelector((state) => state.user);  
  const dispatch = useDispatch();
  const [currentPageTitle, setCurrentPageTitle] = useAtom(
    globalCurrentPageTitle
  )
  if(!locationState&&!(locationState?.from==="onboarding")){
    navigate("/leader/dashboard", { replace: true });
    return;
   }
  return (
    <div className="OnboardingCopyTradeWrap">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal copyTradeDialog"
        show={true}
      >
        <Modal.Body className="onboardingModalBody">
          <div className="onboardingCopyTradeContent">
            <h4 className="businessNameTitle">{selectedCommunity.disPlayName}</h4>
            <img src={setupImage} alt="Setup Icon" className="setupImage" />
            <h2 className="title">Copy Trade Service Added</h2>
            <p className="desc">
              Some things have been added to the menu.
               {/* Your verification is
              still in active.<br /> Click ‘Start’ to set it up.<br /> Use the same exchange
              account to keep your trading history. */}
            </p>
          </div>
          <div
            className="d-sm-flex justify-content-center align-items-center flex-column"
            style={{ gap: "20px" }}
          >
            <BubbleSvgButton
              className="NextBtn"
              text={" Ok, let’s go!"}
              type="button"
              variant="green"
              containerStyling={{
                justifyContent: "center",
              }}
              onClick={()=>{
                dispatch(resetOnBoardingStartContext());
                showNotificationToast("Copy trading is active!", `Your copy trading service is live and ready to share 🚀\n\nYour community can now copy your trades in just a few clicks. Once they sign up, connect, and subscribe—they’re trading what you trade.\n\nShare your landing page to start growing: ${document.location.origin.replace(
                                        document.location.pathname,
                                        ""
                                      )}/community/${user?.leaderCommunity?.name.split(" ").join("")}\n\nTip:\n> Auto-share results to Telegram, Discord, or X. \n> Verify your performance for full transparency`);
                setCurrentPageTitle("Dashboard")
                navigate("/leader/dashboard");
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OnboardingCopyTradeService;
